import { useGetCustomProductLists } from '@hooks/useMembersConfig'
import { useAdminPreview } from '@hooks/useAdminPreview'
import { CustomProductListSlider } from './CustomProducListSlider'

export function CustomProductList() {
  const { data: customProductLists } = useGetCustomProductLists()
  // No preview do produtor toda a lista sairia com a tag de "comprar": o
  // activeForUser do core é `tem matrícula ativa neste produto`, e colaborador
  // não tem nenhuma. Além disso o clique resolveria a matrícula por
  // enrollment(id:), que responde unauthorized. O legado não tem listas
  // customizadas no admin_view, então escondemos.
  const { isPreview } = useAdminPreview()

  if (isPreview) return null

  return (
    <>
      {customProductLists?.map((list) => {
        if (!list.active) return null
        return (
          <CustomProductListSlider
            key={list.id}
            list={list}
            cardFormat={list.kind}
          />
        )
      })}
    </>
  )
}
